module.exports = __webpack_public_path__ + "img/add-action-icon.0ef71d2e.svg";